import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { GlobalModalContext } from '@context/globalModalContext';
import colors from '@general/colors';

Modal.setAppElement('body');

const GlobalModal = ({
    children,
    onClose = () => {},
    setOverlayRef = () => {},
    modalOuterClass,
    modalInnerClass,
    ...props
}) => {
    const [isModalOpen, setIsModalOpen] = useContext(GlobalModalContext);

    // not sure why this is necessary to stop the page from scrolling
    const onAfterOpen = () => {
        const htmlEl = document.getElementsByTagName('html')[0];
        htmlEl.classList.add('ReactModal__HTML--open');
    };
    const onAfterClose = () => {
        const htmlEl = document.getElementsByTagName('html')[0];
        htmlEl.classList.remove('ReactModal__HTML--open');
    };

    const closeModal = () => {
        onClose();
        setIsModalOpen(false);
    };

    return (
        <Modal
            className={modalOuterClass}
            isOpen={isModalOpen}
            style={modalStyles}
            closeTimeoutMS={300}
            onAfterOpen={onAfterOpen}
            onAfterClose={onAfterClose}
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick
            overlayRef={setOverlayRef}
        >
            <div className="d-flex justify-content-end">
                <button
                    type="button"
                    className="close d-flex align-items-center"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={closeModal}
                    style={modalStyles.close}
                >
                    Close{' '}
                    <span style={{ fontSize: '12px' }}>
                        <FontAwesomeIcon
                            style={{ marginLeft: '10px' }}
                            icon={faTimes}
                            color="#000"
                            size="lg"
                            className="cursor-pointer"
                        />
                    </span>
                </button>
            </div>
            <div className={`ReactModal__Body ${modalInnerClass}`}>{children}</div>
        </Modal>
    );
};

const modalStyles = {
    overlay: {
        zIndex: 99999,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: '3% .5rem 0',
        backgroundColor: 'rgba(52, 52, 52, .80)',
    },
    content: {
        position: 'relative',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '10px',
        paddingBottom: '40px',
        margin: '0 auto',
        maxWidth: '500px',
        overflow: 'visible',
        borderRadius: 0,
        borderTopWidth: 6,
        borderTopStyle: 'solid',
        borderTopColor: colors.primary,
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: 'none',
    },
    close: {
        color: '#000',
        fontSize: '12px',
        textTransform: 'uppercase',
        fontFamily: 'Red Hat Display',
        fontWeight: 700,
        marginTop: '20px',
        marginRight: '15px',
    },
};

GlobalModal.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    onClose: PropTypes.func,
    setOverlayRef: PropTypes.func,
    modalOuterClass: PropTypes.string,
    modalInnerClass: PropTypes.string,
};

export default GlobalModal;
